import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import ModalImage from "react-modal-image";
import { Styles } from "./styles/imageGallery.js";

export default class ImageGallery extends Component {

    render() {

        const Datas = 
                    [
                        {
                            "galleryImage": "imagegallery-01.jpg"
                        },
                        {
                            "galleryImage": "imagegallery-02.jpg"
                        },
                        {
                            "galleryImage": "imagegallery-03.jpg"
                        },
                        {
                            "galleryImage": "imagegallery-04.jpg"
                        },
                        {
                            "galleryImage": "imagegallery-05.jpg"
                        },
                        {
                            "galleryImage": "imagegallery-06.jpg"
                        }
                    ]

        return (
            <Styles>
                {/* Campus Tour */}
                <section className="gallery-area">
                    <Container fluid>
                        <Row>
                            {
                                Datas.map((data, i) => (
                                    <Col md="2" sm="6" className="padding-fix" key={i}>
                                        <div className="gallery-box">
                                            <ModalImage small={process.env.PUBLIC_URL + `/assets/images/home/${data.galleryImage}`} large={process.env.PUBLIC_URL + `/assets/images/home/${data.galleryImage}`} alt="" />
                                        </div>
                                    </Col>
                                ))
                            }
                        </Row>
                    </Container>
                </section>
            </Styles>
        )
    }
}
